import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, ViewEncapsulation } from '@angular/core'
import { NgElement, WithProperties } from '@angular/elements'
import { registerCustomElementFactory } from '../../custom-elements/register-custom-element-factory'

/**
 * @public
 */
export type SetItemElement = NgElement & WithProperties<SetItemComponent>

/**
 * @public
 */
@Component({
  selector: 'gpei-set-item',
  templateUrl: './set-item.component.html',
  styleUrls: [ './set-item.component.sass' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: true,
  imports: [ CommonModule ]
})
export class SetItemComponent implements OnInit {

  private _active: boolean

  @Input()
  @HostBinding()
  label: string

  @Input()
  @HostBinding()
  value: string

  ngOnInit(): void {
    if (!this.value) {
      this.value = this.label
    }
  }

  @Input()
  @HostBinding()
  set active(value: string | boolean) {
    let pendingValue = typeof value === 'string' ?
      value.toLowerCase() === 'true' :
      value

    if (this._active !== pendingValue) {
      this._active = pendingValue
    }
  }

  get active(): boolean {
    return this._active
  }

}

/**
 * @public
 */
export const registerSetItemElement = registerCustomElementFactory(SetItemComponent)
